var t = /* @__PURE__ */ new Map(), l = {
  get length() {
    return t.size;
  },
  clear: () => t.clear(),
  getItem: (e) => t.get(e) ?? null,
  key: (e) => [...t.keys()][e] ?? null,
  removeItem: (e) => {
    t.delete(e);
  },
  setItem: (e, a) => {
    t.set(e, a);
  }
}, r, o = (e) => {
  r = e;
}, g = () => {
  if (r) return r;
  try {
    const e = globalThis.localStorage;
    if (e && typeof e.getItem == "function") return e;
  } catch {
  }
  return l;
};
export {
  l as memoryStorage,
  g as resolveDefaultStorage,
  o as setDefaultStorage
};

//# sourceMappingURL=defaultStorage.js.map